module.exports = __webpack_public_path__ + "static/img/3.01569c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/3.png
// module id = TBt0
// module chunks = 0